import React, { useState } from "react";
import Tabs from "../Tabs/Tabs";
import "./CardStats.scss";
import { IoIosTrendingUp, IoIosTrendingDown } from "react-icons/io";

const CardStats = ({
    title,
    subtitle,
    data,
    percentage = true,
    hasChart = false,
    children,
    icon: Icon,
    variant = "default",
    showTabs = true,
    showTrend = false,
    activePeriod = "Semana",
}) => {
    const [activeTab, setActiveTab] = useState(activePeriod);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const currentPeriod = showTabs ? activeTab : activePeriod;
    const currentMetrics = data?.metrics?.[currentPeriod] || {};
    const { amount, percentageValue, trendDirection } = currentMetrics;

    const isNegative = percentageValue < 0 || trendDirection === "down";

    return (
        <div
            className={`card-stats card-stats--${variant} ${
                hasChart ? "card-stats--with-chart" : "card-stats--stats-only"
            }`}
        >
            <div className="card-stats__header">
                <div className="card-stats__info">
                    <div className="card-stats__text">
                        {Icon && (
                            <div className="card-stats__icon">
                                <Icon />
                            </div>
                        )}
                        <div className="card-stats__text-content">
                            <h3 className="card-stats__title">{title}</h3>
                            <p className="card-stats__subtitle">{subtitle}</p>
                        </div>
                    </div>

                    {showTabs && <Tabs onTabChange={handleTabChange} />}
                </div>

                <div className="card-stats__metrics">
                    {showTrend && (
                        <div
                            className={`card-stats__trend-icon ${
                                isNegative
                                    ? "card-stats__trend-icon--negative"
                                    : "card-stats__trend-icon--positive"
                            }`}
                        >
                            {isNegative ? (
                                <IoIosTrendingDown />
                            ) : (
                                <IoIosTrendingUp />
                            )}
                        </div>
                    )}
                    {amount && <h2 className="card-stats__amount">{amount}</h2>}
                    {percentage && percentageValue !== undefined && (
                        <div
                            className={`card-stats__percentage ${
                                isNegative
                                    ? "card-stats__percentage--negative"
                                    : "card-stats__percentage--positive"
                            }`}
                        >
                            <span className="card-stats__percentage-icon">
                                {isNegative ? (
                                    <IoIosTrendingDown />
                                ) : (
                                    <IoIosTrendingUp />
                                )}
                            </span>
                            {Math.abs(percentageValue)}%
                        </div>
                    )}
                </div>
            </div>

            {hasChart && children && (
                <div className="card-stats__content">
                    <div className="card-stats__chart-container">
                        {React.cloneElement(children, {
                            data: data?.chartData,
                            activePeriod: currentPeriod,
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CardStats;
